import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './guards';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';
import { HomeLayoutComponent } from './layouts/home-layout.component';
import { HomeModule } from './dealer/home.module'
import { UserModule } from './user/user.module'
import { LoginModule } from './login/login.module';
import { ErrorLogModule } from './error-log/error-log.module'
import { FileuploadModule } from './file-upload/fileupload.module';
import {ManageDncModule} from './manage-dnc/manage-dnc.module';
import {ForgotPasswordModule} from './forgotpassword/forgot.module';
const appRoutes: Routes = [
    {
        path: '',
        redirectTo: 'dealer/home',
        pathMatch: 'full'
      },
    {
        path: 'login',
        component: SimpleLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
            }
        ]
    },
    {
        path: 'dealer',
        component: HomeLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./dealer/home.module').then(m => m.HomeModule),
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: 'subscriptions',
        component: HomeLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./dealer/home.module').then(m => m.HomeModule),
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: 'dashboard',
        component: HomeLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivate: [AuthGuard]
            }
        ]
    },
     
    {
        path: 'reports',
        component: HomeLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./reports/reports.module').then(m => m.ReportModule),
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: 'dealer',
        component: HomeLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./dealer/home.module').then(m => m.HomeModule),
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: 'user',
        component: HomeLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./user/user.module').then(m => m.UserModule),
                 canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: 'fileupload',
        component: HomeLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./file-upload/fileupload.module').then(m => m.FileuploadModule),
                 canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: 'window',
        children: [
          {
            path: '',
            loadChildren: () => import('./reports/reports.module').then(m => m.ReportModule),
            canActivate: [AuthGuard]
          }
        ]
    },
    {
        path: 'mdnc',
            component: HomeLayoutComponent,
                children: [
                    {
                        path: '',
                        loadChildren: () => import('./manage-dnc/manage-dnc.module').then(m => m.ManageDncModule),
                        canActivate: [AuthGuard]
                    }
                ]
    },
    {
        path: 'mngerlg',
        component: HomeLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./error-log/error-log.module').then(m => m.ErrorLogModule),
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: 'mdnc',
        component: HomeLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./manage-dnc/manage-dnc.module').then(m => m.ManageDncModule),
                canActivate: [AuthGuard]
            }
        ]
    },
  {
    path: 'fgpwd',
    component: SimpleLayoutComponent,
    data: {
      title: 'forgotpassword'
    },
    children: [
      {
        path: '',
        loadChildren: ()=> import( './forgotpassword/forgot.module').then(m => m.ForgotPasswordModule)
      }
    ]
  }

    // otherwise redirect to home
    // { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
